import { render, staticRenderFns } from "./AddressDetail.vue?vue&type=template&id=e666eb16&scoped=true&"
import script from "./AddressDetail.vue?vue&type=script&lang=ts&"
export * from "./AddressDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AddressDetail.vue?vue&type=style&index=0&id=e666eb16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e666eb16",
  null
  
)

export default component.exports